/* tslint:disable */
/* eslint-disable */
/**
 * comici-plus-api
 * # Comici Plus API v1  コンテンツプロバイダーがコンテンツの配信サイトを作成するために利用するAPIを提供します。 
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ユーザーが保有するコインとチケットの情報を表します。
 * @export
 * @interface UserWalletResponseModel
 */
export interface UserWalletResponseModel {
    /**
     * 有料コイン数
     * @type {number}
     * @memberof UserWalletResponseModel
     */
    paidCoin?: number;
    /**
     * ボーナスチケット数
     * @type {number}
     * @memberof UserWalletResponseModel
     */
    bonusValue?: number;
    /**
     * 直近で期限切れとなるコインまたはボーナスチケット数
     * @type {number}
     * @memberof UserWalletResponseModel
     */
    expireValue?: number;
    /**
     * 直近の期限切れ日付のUNIX時間
     * @type {number}
     * @memberof UserWalletResponseModel
     */
    expireDatetime?: number;
    /**
     * ポイントの期限切れカテゴリー
     * * "": None
     * * "C": 有料コイン
     * * "B": ボーナスチケット
     * @type {string}
     * @memberof UserWalletResponseModel
     */
    expireCategory?: UserWalletResponseModelExpireCategoryEnum;
}


/**
 * @export
 */
export const UserWalletResponseModelExpireCategoryEnum = {
    C: 'C',
    B: 'B'
} as const;
export type UserWalletResponseModelExpireCategoryEnum = typeof UserWalletResponseModelExpireCategoryEnum[keyof typeof UserWalletResponseModelExpireCategoryEnum];


/**
 * Check if a given object implements the UserWalletResponseModel interface.
 */
export function instanceOfUserWalletResponseModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserWalletResponseModelFromJSON(json: any): UserWalletResponseModel {
    return UserWalletResponseModelFromJSONTyped(json, false);
}

export function UserWalletResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paidCoin': !exists(json, 'paidCoin') ? undefined : json['paidCoin'],
        'bonusValue': !exists(json, 'bonusValue') ? undefined : json['bonusValue'],
        'expireValue': !exists(json, 'expireValue') ? undefined : json['expireValue'],
        'expireDatetime': !exists(json, 'expireDatetime') ? undefined : json['expireDatetime'],
        'expireCategory': !exists(json, 'expireCategory') ? undefined : json['expireCategory'],
    };
}

export function UserWalletResponseModelToJSON(value?: UserWalletResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paidCoin': value.paidCoin,
        'bonusValue': value.bonusValue,
        'expireValue': value.expireValue,
        'expireDatetime': value.expireDatetime,
        'expireCategory': value.expireCategory,
    };
}

